import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { RoleTest, RoleListContainer, BreadcrumbContainer } from "./Styles";
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemSubtitle,
  ListGroupItemTitle,
} from "@vds/lists";
import { useSelector, useDispatch } from "react-redux";
import { getRoles } from "../../model/roleService";
import { hasPermission } from "../../global/utility/permissionUtils";
import NotificationBanner from "../../layouts/NotificationBanner";
import { Notification } from "@vds/notifications";
import { showNotificationBanner } from "../../store/actions";
import { Loader } from "@vds/loaders";
const Roles = () => {
  const [rolesList, setRolesList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showNotification, setShowNotification] = useState(false);
  const isCreateRoleEnabled =
    window.REACT_APP_FEATURE_CUSTOM_ROLES === "enabled";

  const editRole = (resourceIdentifier) => {
    navigate(`/editRole?roleId=${encodeURIComponent(resourceIdentifier)}`);
  };

  const createRole = () => {
    if (!hasPermission("Role management", "Create")) {
      showPermissionsBanner();
    } else {
      navigate(`/createRole`);
    }
  };
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );

  const roleResponse = async () => {
    try {
      const roleList = await getRoles(activeSession);
      console.log("setRolesList", roleList);
      if (roleList) {
        setRolesList(roleList);
      } else {
        setRolesList([]);
      }
    } catch (error) {
      console.log("Getting error", error);
    }
  };

  useEffect(() => {
    roleResponse();
  }, []);

  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission",
      priority: "critical",
      showNotification: true,
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  return (
    <>
      {rolesList.length === 0 ? (
        <div className="page-loader-wrapper">
          <Loader fullscreen={false} active={true} surface="light" />
        </div>
      ) : (
        <>
          <BreadcrumbContainer>
            <Breadcrumbs surface="light">
              <BreadcrumbItem>
                <Link
                  data-testid="roles_settingsLink"
                  to="/settings"
                  className="breadcrums-item_link"
                >
                  Settings
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem>Roles</BreadcrumbItem>
            </Breadcrumbs>
          </BreadcrumbContainer>
          <br />
          <h2 className="breadcrumb-css">Roles</h2>
          <br />
          <RoleTest>
            Roles allow site admins to determine the permissions for different
            user groups. We’ve provided some modifiable templates to help your
            organization get started.
          </RoleTest>
          <RoleListContainer>
            <ListGroup
              topLine={false}
              bottomLine={true}
              surface="light"
            >
              {rolesList && Array.isArray(rolesList) && rolesList.length > 0
                ? rolesList.map((role) => (
                    <ListGroupItem
                      key={role.id}
                      actionElement="textLink"
                      textLink={{
                        text: "Edit template",
                      }}
                      data-testid="roles_editTemplateTextLink"
                      onClick={() => editRole(role.id)}
                    >
                      <ListGroupItemTitle bold={false}>
                        {role.name}
                      </ListGroupItemTitle>
                      <ListGroupItemSubtitle>
                        {role.description}
                      </ListGroupItemSubtitle>
                    </ListGroupItem>
                  ))
                : null}
            </ListGroup>
          </RoleListContainer>
          <RoleListContainer>
            <ListGroup>
              {isCreateRoleEnabled ? (
                <ListGroupItem
                  actionElement="textLink"
                  textLink={{
                    text: "Create role",
                  }}
                  data-testid="roles_createRoleListGroupItem"
                  onClick={() => createRole()}
                >
                  <ListGroupItemTitle bold={false}>
                    Create a role
                  </ListGroupItemTitle>
                  <ListGroupItemSubtitle>
                    Create a role with custom permissions to suit your
                    organization’s needs.
                  </ListGroupItemSubtitle>
                </ListGroupItem>
              ) : null}
            </ListGroup>
          </RoleListContainer>
        </>
      )}
    </>
  );
};

export default Roles;
